/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
// template components
import RelatedLinks from '@nmx/template/dist/componentLibrary/layout/Footer/RelatedLinks';

export const RelatedLinksStyled = styled(RelatedLinks)`
  padding-bottom: 0;
`;
